export const MEGA_BROKER_API = '__MEGA_BROKER__';
export const MEGA_TRANSFER_PORT = '__MEGA_TRANSFER_PORT__';
export function createMegaServiceAPI(serviceName, apiKey) {
    return ['__MEGA_SERVICE_API__', serviceName, apiKey].join(':');
}
export function createInternalAPI(apiKey) {
    return ['__MEGA_INTERNAL_API__', apiKey].join(':');
}
export const MEGA_INTERNAL_API_LOAD_PROTOCOL = createInternalAPI('loadProtocol');
//# sourceMappingURL=constants.js.map